import React, { useEffect } from 'react'
import { Container, Row, Col, CardText, CardBody,
  CardTitle, Button } from 'reactstrap'
import { CustomEase } from 'gsap/CustomEase'
import { gsap } from 'gsap'
gsap.registerPlugin(CustomEase)

const arrow = '/assets/animation_graphics/arrow.svg'
const barLeft = '/assets/animation_graphics/bar-left.svg'
const barMiddle = '/assets/animation_graphics/bar-middle.svg'
const barRight = '/assets/animation_graphics/bar-right.svg'
const calculator = '/assets/animation_graphics/calculator.svg'
const coin = '/assets/animation_graphics/Coin.svg'
const graphicLeft = '/assets/animation_graphics/graphic-left.svg'
const graphicTop = '/assets/animation_graphics/graphic-top.svg'
const graphicRight = '/assets/animation_graphics/graphic-right.svg'
const graphicLine = '/assets/animation_graphics/graphic-line.svg'

function Slide1 ({ onNextRequested }) {
  useEffect(() => {
    const tl = gsap.timeline({ delay: 2 })
    const ease = CustomEase.create('custom', 'M0,0 C0,0 0.08318,0.2664 0.14193,0.43905 0.18286,0.55934 0.20602,0.62375 0.25214,0.74102 0.28228,0.81765 0.30017,0.86241 0.33637,0.93344 0.3573,0.97452 0.37697,1.00924 0.40222,1.0355 0.41087,1.0445 0.4313,1.04891 0.44292,1.04424 0.47803,1.03013 0.50891,0.9985 0.549,0.97651 0.56111,0.96986 0.5734,0.96353 0.58554,0.96601 0.64121,0.97737 0.69575,1.01266 0.75196,1.01793 0.78272,1.02082 0.81262,0.99138 0.84322,0.99016 0.86491,0.98929 0.88642,1.0117 0.90731,1.01173 0.92467,1.01175 0.94141,0.99256 0.95928,0.9903 0.97259,0.98862 1,1 1,1')

    tl.from('.calculator', { alpha: 0, duration: 0.1 })
    tl.from('.calculator', { transformOrigin: 'bottom', scaleY: 0.1, ease, duration: 0.5 }, '-=.1')
    tl.from('.graphic-line', { alpha: 0, duration: 0.1 }, '-=.45')
    tl.from('.graphic-line', { x: -150, duration: 0.5 }, '-=.5')
    tl.from('.coin', { alpha: 0, duration: 0.1 }, '-=0.35')
    tl.from('.coin', { transformOrigin: 'bottom', scaleY: 0.1, y: 7, ease, duration: 0.5 }, '-=.3')
    tl.from('.arrow', { alpha: 0, rotation: 75, duration: 0.4 }, '-=.3')
    tl.from('.bar-left', { scaleY: 0, duration: 0.25 }, '-=.3')
    tl.from('.bar-middle', { scaleY: 0, duration: 0.25 }, '-=.2')
    tl.from('.bar-right', { scaleY: 0, duration: 0.25 }, '-=.1')
    tl.from('.graphic-left', { y: 380, ease, duration: 0.5 }, '-=.1')
    tl.from('.graphic-top', { y: -280, ease, duration: 0.5 }, '-=.5')
    tl.from('.graphic-right', { x: 310, ease, duration: 0.5 }, '-=.5')

    tl.timeScale('1.1')
  }, [])
  return (
    <CardBody className='app-slide Slide1 w-100'>
      <Container fluid>
        <Row>
          <Col xs={{ size: 12, order: 2 }} xl={{ size: 6, offset: 1, order: 1 }} className='content-col'>
            <CardTitle className='pb-xl-2'><h2>How much life insurance is right for you?</h2></CardTitle>
            <CardText className='pb-2'>Calculating the amount of life insurance you need can be challenging. That’s why we’re here to help! With this simple and easy-to-use tool, you’ll be able to determine how much life insurance is right for you and protect your family in the event of your death.</CardText>
            <Button className='btn-begin' onClick={onNextRequested}>Begin</Button>
          </Col>
          <Col xs={{ size: 12, order: 1 }} xl={{ size: 5, order: 2 }} className='d-flex justify-content-center'>
            <div className='graphic-wrapper'>
              <div className='animation-wrapper'>
                <img className='animated-graphic arrow' src={arrow} alt='' />
                <img className='animated-graphic bar-left' src={barLeft} alt='' />
                <img className='animated-graphic bar-middle' src={barMiddle} alt='' />
                <img className='animated-graphic bar-right' src={barRight} alt='' />
                <img className='animated-graphic calculator' src={calculator} alt='' />
                <img className='animated-graphic coin' src={coin} alt='' />
                <img className='animated-graphic graphic-left' src={graphicLeft} alt='' />
                <img className='animated-graphic graphic-top' src={graphicTop} alt='' />
                <img className='animated-graphic graphic-right' src={graphicRight} alt='' />
                <img className='animated-graphic graphic-line' src={graphicLine} alt='' />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </CardBody>

  )
}
export default Slide1
